import { PaymentWorkflowType } from '../components/container/forms/types/api/graph.types';
import { workflowsRegistry } from './workflowRegistry';

// Simple mobile detection using viewport width and user-agent as a fallback
export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  const smallViewport = window.matchMedia
    ? window.matchMedia('(max-width: 767px)').matches
    : window.innerWidth <= 767;
  const ua = navigator.userAgent || navigator.vendor || '';
  const uaMobile = /android|iphone|ipad|ipod|iemobile|blackberry|bb10/i.test(
    ua
  );
  return smallViewport || uaMobile;
};

// List workflow keys (ids from workflowRegistry) that are restricted on mobile
// Example ids: 'dubai-payment-approval', 'dubai-transfer-requisition', etc.
export const mobileRestrictedWorkflowIds: readonly string[] = [
  'dubai-payment-approval',
];

export const isWorkflowRestrictedOnMobile = (workflowKey?: string | null) => {
  if (!workflowKey) return false;
  return mobileRestrictedWorkflowIds.includes(workflowKey);
};

/**
 * Maps workflow registry IDs to their corresponding PaymentWorkflowType enum values
 * @param workflowIds Array of workflow registry IDs
 * @returns Array of PaymentWorkflowType enum values
 */
export const getWorkflowTypesFromIds = (
  workflowIds: readonly string[]
): PaymentWorkflowType[] => {
  return workflowIds
    .map((id) => workflowsRegistry[id]?.workflowType)
    .filter(
      (workflowType): workflowType is PaymentWorkflowType =>
        workflowType !== undefined &&
        workflowType !== PaymentWorkflowType.Undefined
    );
};

/**
 * Gets the PaymentWorkflowType enum values that are restricted on mobile
 * @returns Array of PaymentWorkflowType enum values that are mobile-restricted
 */
export const getMobileRestrictedWorkflowTypes = (): PaymentWorkflowType[] => {
  return getWorkflowTypesFromIds(mobileRestrictedWorkflowIds);
};

/**
 * Filters out mobile-restricted workflow types from a list of allowed workflow types
 * @param allowedWorkflowTypes Array of allowed PaymentWorkflowType enum values
 * @returns Filtered array with mobile-restricted workflow types removed
 */
export const filterMobileRestrictedWorkflowTypes = (
  allowedWorkflowTypes: PaymentWorkflowType[]
): PaymentWorkflowType[] => {
  const isMobile = isMobileDevice();
  if (!isMobile) return allowedWorkflowTypes;

  const restrictedTypes = getMobileRestrictedWorkflowTypes();
  return allowedWorkflowTypes.filter(
    (workflowType) => !restrictedTypes.includes(workflowType)
  );
};
